export default __webpack_public_path__ + "files/5a88621db556f9c5bbc20dd5f50e55af.svg";